import styled, { css } from 'styled-components';

import { styledMedia, styledTypography } from '@pkg/primitives';

import { tokens } from './NonEditablePrice.tokens';

const textBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.02em;
`;

export const StyledNonEditablePrice = styled.div`
    display: grid;
    justify-content: end;
    justify-items: end;
    gap: ${tokens.gap}px;
    flex: 1 1 auto;
`;

export const UsdText = styled.p`
    ${textBase};
    font-size: ${tokens.usdSize}px;
    font-weight: 700;
`;

export const NativePriceWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: ${tokens.gap}px;
`;

export const CurrencyIconWrapper = styled.div`
    ${styledMedia.iconWrapper};
    padding: 2px;
    width: ${tokens.nativeSize}px;
    height: ${tokens.nativeSize}px;
    border-radius: 999px;
    background-color: rgb(255, 255, 255, 0.1);
`;

export const NativeText = styled.p`
    ${textBase};
    font-size: ${tokens.nativeSize}px;
    font-weight: 600;
    color: rgb(255, 255, 255, 0.5);
`;
